import { Injectable } from '@angular/core';
import { ChecklistAnswer } from '../classes/checklist-answer';
import { ChecklistCompleted } from '../classes/checklist-completed';
import { ApiService } from './api/api.service';

@Injectable({
    providedIn: 'root',
})
export class ChecklistService {
    constructor(private apiService: ApiService) {}

    getPdf(id: number) {
        return this.apiService.getBlobCall(`checklist/answers/pdf/${id}`);
    }

    saveAnswers(checklist: ChecklistCompleted) {
        return this.apiService.postCall$<ChecklistCompleted>('checklist/answers', checklist);
    }

    getAnswers(id: number) {
        return this.apiService.getCall$<ChecklistCompleted>(`checklist/answers/${id}`);
    }

    listAnswers() {
        return this.apiService.getCall$<ChecklistCompleted[]>(`checklist/answers`);
    }

    hasPendingSignOff() {
        return this.apiService.getCall$<boolean>(`checklist/answers/pending-sign-off`);
    }

    deleteAnsweredChecklist(id: number) {
        return this.apiService.deleteCall$(`checklist/answers/${id}`);
    }

    signOff(answerId: number) {
        return this.apiService.postCall$<ChecklistAnswer>(`checklist/answers/${answerId}/sign-off`, {});
    }
}
